import { render, staticRenderFns } from "./ModalReset.vue?vue&type=template&id=0ec68788&scoped=true"
import script from "./ModalReset.vue?vue&type=script&lang=js"
export * from "./ModalReset.vue?vue&type=script&lang=js"
import style0 from "./ModalReset.vue?vue&type=style&index=0&id=0ec68788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec68788",
  null
  
)

export default component.exports